module.exports = __webpack_public_path__ + "static/media/men.36ecce7a.jpg";